// @ts-nocheck
/* eslint-disable */
module.exports = {
  languageData: {
  "plurals": function (n, ord) {
    if (ord) return "other";
    return n == 1 ? "one" : "other";
  }
},
  messages: {
    "(Name of your language) translation": "Traducci\xF3n en espa\xF1ol",
    "(Note: the email will be sent in English)": "(Nota: tenga en cuenta que el correo electr\xF3nico se enviar\xE1 en ingl\xE9s)",
    "(optional)": "(opcional)",
    "<0/> makes use of a <1/> and <2/>, which you can review.": "<0/> usa una <1/> y unos <2/>, que puedes revisar.",
    "<0>Free tools for you to fight for a safe and healthy home</0><1>Enter your address to learn more.</1>": "<0>Herramientas gratuitas para luchar por un hogar seguro y saludable</0><1>Introduce tu direcci\xF3n para saber m\xE1s.</1>",
    "<0>To</0><1/><2>From</2><3/>": "<0>De</0><1/><2>Hasta</2><3/>",
    "About": "Acerca de",
    "About you": "Sobre usted",
    "Actions": "Acciones",
    "Address": "Direcci\xF3n",
    "After this step, you cannot go back to make changes. But don’t worry, we’ll explain what to do next.": "Despu\xE9s de este paso, no puedes volver a hacer cambios. Pero no te preocupes, te explicaremos qu\xE9 hacer despu\xE9s de enviar la carta.",
    "Alabama": "Alabama",
    "Alas.": "Mecachis.",
    "Alaska": "Alaska",
    "Apartment needs painting": "El apartamento necesita pintura",
    "Apartment number": "N\xFAmero de apartamento",
    "Are you sure you want to log out?": "\xBFEst\xE1s seguro de que quieres cerrar la sesi\xF3n?",
    "Are you sure you want to proceed with the following address?": "\xBFSeguro que quieres continuar con la siguiente direcci\xF3n?",
    "Arizona": "Arizona",
    "Arkansas": "Arkansas",
    "Back": "Atr\xE1s",
    "Back door": "Puerta trasera",
    "Baseboards defective": "Z\xF3calo defectuoso",
    "Bathroom": "Ba\xF1o",
    "Bathtub: cracked tub": "Ba\xF1era: agrietada",
    "Bathtub: drain stoppage": "Ba\xF1era: desag\xFCe atascado",
    "Bathtub: faucets not installed": "Ba\xF1era: no hay grifo",
    "Bathtub: faucets not working": "Ba\xF1era: grifo no funciona",
    "Bathtub: leaky faucet": "Ba\xF1era: grifo con fugas",
    "Bathtub: pipes leaking": "Ba\xF1era: tuber\xEDas con fugas",
    "Bedroom": "Rec\xE1mara",
    "Broken": "Quebrado",
    "Broken/defective windows": "Ventanas quebradas/defectuosas",
    "Broken/insecure locks": "Seguros quebrados/defectuosos",
    "Broken/no smoke/Co2 detector": "Sin detector de Co2 o humo",
    "Bug infestation": "Infestaci\xF3n de insectos",
    "Bug infestation (roaches, bedbugs, ... )": "Infecci\xF3n de bichos (cucarachas, chinches, ... )",
    "Build my letter": "Crear mi carta",
    "Build your letter": "Crea tu carta",
    "Building and safety": "Construcci\xF3n y seguridad",
    "Building exit": "Salida del edificio",
    "Building main entrance": "Entrada principal del edificio",
    "Building parking entrance": "Entrada de estacionamiento del edificio",
    "Buildings in your landlord's portfolio are located in {0, plural, one {one zip code.} other {# zip codes.}}": function (a) {
  return ["Los edificios en el portafolio del due\xF1o de tu edificio se encuentran en ", a("0", "plural", {
    one: "un c\xF3digo postal.",
    other: ["#", " c\xF3digo postales."]
  })];
},
    "Buzzer not working": "El timbre del edificio no funciona",
    "California": "California",
    "Can't pay rent?": "\xBFNo puedes pagar la renta?",
    "Cancel": "Cancelar",
    "Ceiling falling/fell": "Techo colapsado/se colapsa",
    "Ceiling leaking": "Techo gotea",
    "Change": "Cambiar",
    "Change city and state from {cityAndState}": function (a) {
  return ["Cambiar ciudad y estado de ", a("cityAndState")];
},
    "City": "Ciudad",
    "City and state": "Ciudad y estado",
    "City/township/borough": "Ciudad/pueblo/municipalidad",
    "Click here to learn more about our privacy policy.": "Haga clic aqu\xED para obtener m\xE1s informaci\xF3n sobre nuestra pol\xEDtica de privacidad.",
    "Cockroaches": "Cucarachas",
    "Colorado": "Colorado",
    "Common areas (parking, hallway, etc.)": "\xC1reas comunes (estacionamiento, pasillo, etc)",
    "Confirm": "Confirmar",
    "Confirm your new password": "Confirma tu nueva contrase\xF1a",
    "Confirming the address": "Confirmando la direcci\xF3n",
    "Confirming the city": "Confirmando la ciudad",
    "Connecticut": "Connecticut",
    "Contact": "Contacta",
    "Contact a lawyer if your landlord retaliates": "Ponte en contacto con un abogado si el due\xF1o de tu edificio toma represalias",
    "Continue": "Continuar",
    "Cracked sink": "Lavabo agrietado",
    "Cracked walls": "Paredes Agrietadas",
    "Create a password": "Crea una contrase\xF1a",
    "Date": "Fecha",
    "Date (optional)": "Fecha (opcional)",
    "Dear <0/>,": "Estimado/a <0/>,",
    "Defective electricity": "Electricidad defectuosa",
    "Defective plumbing": "Plomer\xEDa defectuosa",
    "Delaware": "Delaware",
    "Developed with <0>Law Help Interactive</0>": "Desarrollado con <0>Law Help Interactive</0>",
    "Dining room": "Comedor",
    "District of Columbia": "Distrito de Columbia",
    "Do you live in {0}, {1}?": function (a) {
  return ["\xBFVives en ", a("0"), ", ", a("1"), "?"];
},
    "Do you still want to mail to:": "\xBFA\xFAn deseas continuar?",
    "Don’t worry, we’ll save your progress so you’ll be able to come back to your last step when you log back in.": "No te preocupes, guardaremos tus respuestas para que puedas empezar desde donde te quedaste cuando vuelvas a conectarte.",
    "Door lock not working": "Cerradura de la puerta no funciona",
    "Door not working": "Puerta no funciona",
    "Doorbell not working": "El timbre de la casa no funciona",
    "Drain stoppage": "Desag\xFCe atascado",
    "Dryer not working": "Secadora no funciona",
    "Edit": "Editar",
    "Electric wiring exposed": "Alambrado El\xE9ctrico Expuesto",
    "Electricity": "Electricidad",
    "Electricity not working": "La electricidad no funciona",
    "Email address": "Correo electr\xF3nico",
    "English version": "Versi\xF3n en ingl\xE9s",
    "Enter your address to see some recommended actions.": "Introduce tu direcci\xF3n para ver algunas acciones recomendadas.",
    "FAQs": "Preguntas Frecuentes",
    "Faqs": "Preguntas frecuentes",
    "Faucets not installed": "Grifos No Instalados",
    "Faucets not working": "Grifos No Funcionan",
    "Faulty doors": "Puerta defectuosa",
    "Floor level": "Nivel de piso",
    "Floor sags": "Piso hundido",
    "Florida": "Florida",
    "Frequently Asked Questions": "Preguntas Frecuentes",
    "Front door": "Puerta principal",
    "Front door not working": "Puerta principal no funciona",
    "Fumes/smoke entering apartment": "Vapores/Humo Entrando en Casa",
    "Gas": "Gas",
    "Georgia": "Georgia",
    "Go back": "Atr\xE1s",
    "Got it": "Entendido",
    "Got it, take me there": "Entendido, ll\xE9vame",
    "Habitability (CA)": "Habitabilidad (CA)",
    "Hallway": "Pasillo",
    "Harassment (CA)": "Acoso (CA)",
    "Harassment (LA City/TAHO)": "Acoso (Ciudad de Los \xC1ngeles/TAHO)",
    "Hawaii": "Hawaii",
    "Health": "Salud",
    "Hello world": "Hola mundo",
    "Help": "Ayuda",
    "Holes": "Agujeros",
    "Homepage": "P\xE1gina Principal",
    "How do you protect my personal information?": "\xBFC\xF3mo protegen mis datos personales?",
    "How it works": "C\xF3mo funciona",
    "I agree to the <0/> terms and conditions.": "Acepto los t\xE9rminos y condiciones de <0/>.",
    "I forgot my password": "He perdido mi contrase\xF1a",
    "I have no apartment number": "No tengo ning\xFAn n\xFAmero de apartamento",
    "Idaho": "Idaho",
    "If you didn't receive a code, try checking your email. If it's not in there either, please email <0/>.": "Si no recibiste un c\xF3digo, comprueba tu correo electr\xF3nico. Si no lo encuentras, por favor env\xEDa un correo electr\xF3nico a <0/>.",
    "If you need to make changes to your name or contact information, please contact <0/>.": "Si necesitas cambiar tu nombre o tu informaci\xF3n de contacto, ponte en contacto con <0/>.",
    "If you write checks or transfer money through your bank to pay your rent, use that name here.": "Usa el nombre al que pagas la renta.",
    "Illinois": "Illinois",
    "Inadequate water pressure": "Presi\xF3n de Agua Inadecuada",
    "Inadequate/no super service": "Servicio de s\xFAper inadecuado",
    "Indiana": "Indiana",
    "Iowa": "Iowa",
    "Is this free?": "\xBFEs gratis?",
    "It doesn't seem like this property is required to register with HPD. You can learn about the City's registration requirements on <0>HPD's Property Management page</0>.": "Parece que esta propiedad no tiene que estar registrada con el HPD. Puedes aprender los requisitos de registro de la ciudad en la p\xE1gina <0>Gesti\xF3n de Propiedad de HPD</0>.",
    "It’s your first time here!": "\xA1Es la primera vez que est\xE1s aqu\xED!",
    "JustFix is a registered 501(c)(3) nonprofit organization.": "JustFix es una organizaci\xF3n registrada 501(c)(3) sin fines de lucro.",
    "Kansas": "Kansas",
    "Kentucky": "Kentucky",
    "Kitchen": "Cocina",
    "Landlord address": "Direcci\xF3n de correo del due\xF1o de tu edificio",
    "Landlord name": "Nombre del due\xF1o de tu edificio",
    "Landlord/management company's email": "Direcci\xF3n de correo electr\xF3nico del due\xF1o o manager de tu edificio",
    "Landlord/management company's name": "Nombre del due\xF1o o manager de tu edificio",
    "Language:": "Idioma:",
    "Laundry room": "Lavanderia",
    "Lead-based paint": "Pintura a base de plomo",
    "Leaky faucet": "Grifo con fugas",
    "Learn about why we made this tool, who we are, and who our partners are.": "Aprenda por qu\xE9 hemos construido esta herramienta, qui\xE9nes somos, y qui\xE9nes son nuestros aliados.",
    "Learn about your rent": "Aprende Sobre Tu Alquiler",
    "Learn more": "Aprender m\xE1s",
    "Learn more about our mission on our website": "Obt\xE9n m\xE1s informaci\xF3n a cerca de nuestra misi\xF3n en nuestro sitio web (s\xF3lo en ingl\xE9s)",
    "Legal first name": "Primer nombre legal",
    "Legal last name": "Apellido legal",
    "Legal name": "Nombre legal",
    "Legally vetted": "Verificado legalmente",
    "Let's get to know you.": "Conozc\xE1monos.",
    "Let's set you up with a new password, so you can easily login again.": "Configuremos una nueva contrase\xF1a, para que puedas volver f\xE1cilmente.",
    "Living room": "Sala",
    "Log in": "Iniciar sesi\xF3n",
    "Log out": "Cerrar sesi\xF3n",
    "Looks like you're already logged in": "Parece ser que ya has iniciado tu sesi\xF3n",
    "Looks like you're not logged in": "Parece que no has iniciado ninguna sesi\xF3n",
    "Looks like you've been here before. Click \"Next\" to be taken to where you left off.": "Parece que ya estuviste aqu\xED antes. Haz clic en \"Continuar\" para seguir desde donde te quedaste.",
    "Loose floor": "Piso suelto",
    "Louisiana": "Luisiana",
    "Made with NYC ♥ by the team at <0>JustFix</0>": "Hecho en NYC con \u2665 por el equipo de <0>JustFix</0>",
    "Mail for me": "Enviar para mi",
    "Mail myself": "Enviar yo mismo",
    "Mailing address": "Direcci\xF3n postal",
    "Maine": "Maine",
    "Maryland": "Maryland",
    "Massachusetts": "Massachusetts",
    "Mice": "Ratones",
    "Michigan": "Michigan",
    "Minnesota": "Minnesota",
    "Mississippi": "Misisipi",
    "Missouri": "Misuri",
    "Mold": "Moho",
    "Mold on walls": "Muros Con Moho",
    "Montana": "Montana",
    "More actions": "M\xE1s acciones",
    "Must be at least 14 days from today.": "Debe tener al menos 14 d\xEDas a partir de hoy.",
    "Must be at least 8 characters. Can't be all numbers.": "Debe tener por lo menos 8 letras. No se puede usar solo n\xFAmeros.",
    "Nebraska": "Nebraska",
    "Nevada": "Nevada",
    "New Hampshire": "Nuevo Hampshire",
    "New Jersey": "Nueva Jersey",
    "New Mexico": "Nuevo M\xE9xico",
    "New York": "Nueva York",
    "New password": "Contrase\xF1a nueva",
    "Next": "Continuar",
    "No": "No",
    "No cold water": "Sin agua fr\xEDa",
    "No gas": "Sin gas",
    "No heat": "Sin calefacci\xF3n",
    "No hot water": "Sin agua caliente",
    "No registration found.": "No hay fecha de registro.",
    "No rent receipts given": "No se dan recibos de alquiler",
    "No smoke detector": "Sin detector de humo",
    "North Carolina": "Carolina del Norte",
    "North Dakota": "Dakota del Norte",
    "Not enough": "Insuficiente",
    "Now we just need your password. This is the same one you’ve used on JustFix or NoRent.": "Ahora solo necesitamos tu contrase\xF1a. Esta es la misma que usas en JustFix o NoRent.",
    "Ohio": "Ohio",
    "Oklahoma": "Oklahoma",
    "Oops! A network error occurred. Try again later.": "\xA1Vaya! Hubo un error en la red. Int\xE9ntalo m\xE1s tarde.",
    "Order rent history": "Pedir Historial de Renta",
    "Oregon": "Oreg\xF3n",
    "Other": "Otro",
    "Our Partners": "Nuestros aliados",
    "Our records have shown us a similar address. Would you like to proceed with this address:": "Nuestros registros han encontrado una direcci\xF3n similar. \xBFQuieres continuar con la direcci\xF3n siguiente?",
    "Our records tell us that this address is invalid.": "Nuestros registros indican que esta direcci\xF3n no es v\xE1lida.",
    "Our records tell us that this address is undeliverable.": "Nuestros registros indican que no se puede enviar correo a esta direcci\xF3n.",
    "Outlets not working": "Tomas de corriente no funcionan",
    "Painting overdue (3 years)": "Pintura Atrasada (cada 3 a\xF1os)",
    "Password": "Contrase\xF1a",
    "Peeling paint": "Pintura Se Descama",
    "Peeling/flaking paint": "Pintura Escamada/Pelada",
    "Pennsylvania": "Pensilvania",
    "Phone number": "N\xFAmero de tel\xE9fono",
    "Pipes leaking": "Tuber\xEDas con fugas",
    "Please agree to our terms and conditions": "Por favor, acepta nuestros t\xE9rminos y condiciones",
    "Please confirm your password": "Por favor confirma tu contrase\xF1a",
    "Please enter your landlord's name and contact information below. You can find this information on your lease and/or rent receipts.": "Por favor, proporciona el nombre del due\xF1o de tu edificio as\xED como su informaci\xF3n de contacto. Puedes encontrar esta informaci\xF3n en tu contrato de arrendamiento y/o tus recibos de alquiler.",
    "Please use a number that can receive text messages.": "Por favor, usa un n\xFAmero que pueda recibir mensajes de texto.",
    "Preferred first name": "Nombre de preferencia",
    "Preferred first name (optional)": "Nombre preferido (opcional)",
    "Privacy Policy": "Pol\xEDtica de Privacidad",
    "Puerto Rico": "Puerto Rico",
    "Radiators/risers not working": "Radiadores/tubos de subida no funcionan",
    "Rats": "Ratas",
    "Rats/mice": "Ratas/ratones",
    "Recommended actions": "Acciones recomendadas",
    "Refrigerator not working": "Refrigerador no funciona",
    "Regards,": "Atentamente,",
    "Rent receipts incomplete": "Recibos de Alquiler Incompletos",
    "Request repairs from your landlord": "Solicitar arreglos del due\xF1o de tu edificio",
    "Research your landlord": "Investiga al due\xF1o de tu edificio",
    "Reset your password": "Cambia tu contrase\xF1a",
    "Results for {0}": function (a) {
  return ["Resultados para \"", a("0"), "\""];
},
    "Rhode Island": "Rhode Island",
    "Right to Privacy (CA)": "Derecho a la Privacidad (CA)",
    "Rodent infestation (mice, rats, ... )": "Infestaci\xF3n de roedores (ratones, ratas, ... )",
    "Rusty water": "Agua Oxidada",
    "Save": "Guardar",
    "Search address": "Direcci\xF3n de b\xFAsqueda",
    "See more FAQs": "Ver todas las preguntas frecuentes",
    "Select at least one date when you'll be available for repairs": "Selecciona al menos una fecha cuando est\xE9s disponible para reparaciones",
    "Send a letter of complaint": "Enviar una carta de queja",
    "Send code": "Enviar c\xF3digo",
    "Set up an account": "Configura tu cuenta",
    "Set your new password": "Establece tu nueva contrase\xF1a",
    "Set your password": "Establece tu contrase\xF1a",
    "Share this tool": "Compartir esta herramienta",
    "Shower: drain stoppage": "Ducha: desag\xFCe atascado",
    "Shower: leaky shower head": "Ducha: alcachofa de ducha rota",
    "Shower: low water pressure": "Ducha: baja presi\xF3n de agua",
    "Shower: mold on walls": "Ducha: moho sobre las paredes",
    "Shower: not working": "Ducha: no funciona",
    "Shower: wall tiles cracked": "Ducha: baldosas agrietadas",
    "Shower: wall tiles missing": "Ducha: faltan baldosas",
    "Sign in": "Iniciar sesi\xF3n",
    "Sign out": "Cerrar sesi\xF3n",
    "Sign up or log in to your account to access our tool.": "Reg\xEDstrate o inicia una sesi\xF3n en tu cuenta para acceder a nuestra herramienta.",
    "Signed,": "Firmado,",
    "Sink: cracked sink": "Lavabo: agrietado",
    "Sink: drain stoppage": "Lavabo: desag\xFCe atascado",
    "Sink: faucets not installed": "Lavabo: sin grifo",
    "Sink: faucets not working": "Lavabo: grifo no funciona",
    "Sink: leaky faucet": "Lavabo: grifo con fugas",
    "Sink: low water pressure": "Lavabo: baja presi\xF3n de agua",
    "Sink: pipes leaking": "Lavabo: tuber\xEDas con fugas",
    "Smoke detector not working": "Detector de humo no funciona",
    "Smoke or carbon monoxide detector": "Detectores de humos y mon\xF3xido de carbono",
    "Sorry, the page you are looking for doesn't seem to exist.": "Lo sentimos, la p\xE1gina que est\xE1s buscando no existe.",
    "Sorry, we don't recognize the address you entered.": "Lo sentimos, no reconocemos la direcci\xF3n que has introducido.",
    "South Carolina": "Carolina del Sur",
    "South Dakota": "Dakota del Sur",
    "Start": "Iniciar",
    "Start a legal case for repairs and/or harassment": "Empieza un caso legal por arreglos y/o acoso",
    "State": "Estado",
    "Step {0} of {1}": function (a) {
  return ["Paso ", a("0"), " de ", a("1")];
},
    "Stove not working": "Estufa no funciona",
    "Strategic Actions for a Just Economy": "Strategic Actions for a Just Economy",
    "Street address (include unit/suite/floor/apt #)": "Direcci\xF3n (incluye unidad/suite/piso/apt #)",
    "Subject: {0}": function (a) {
  return ["Tema: ", a("0")];
},
    "Take action": "Toma acci\xF3n",
    "Tennessee": "Tennessee",
    "Terms of Use": "T\xE9rminos de Uso",
    "Texas": "Tejas",
    "The majority of your landlord's properties are concentrated in {0}.": function (a) {
  return ["La mayor\xEDa de las propiedades del due\xF1o de tu edificio se concentran en ", a("0"), "."];
},
    "The name used in letters to your landlord and legal documents": "El nombre que usas en las cartas al propietario y en documentos legales",
    "The name you'd like to be called.": "Nombre que te gusta que te llamen.",
    "The webpage that you want to access is only available in English.": "La p\xE1gina web a la que quieres acceder solo est\xE1 disponible en ingl\xE9s.",
    "There {0, plural, one {is one unit} other {are # units}} in your building.": function (a) {
  return ["Hay ", a("0", "plural", {
    one: "una unidad",
    other: ["#", " unidades"]
  }), " en tu edificio."];
},
    "Think your apartment may be rent-stabilized? Request its official records.": "\xBFCrees que tu apartamento puede ser de renta estabilizada? Solicita el registro oficial.",
    "This building is owned by the <0>NYC Housing Authority (NYCHA)</0>.": "Este edificio es propiedad de la <0>NYC Housing Authority (NYCHA)</0>.",
    "This information seems wrong. Can I change it?": "Esta informaci\xF3n parece incorrecta. \xBFPuedo cambiarla?",
    "This is optional.": "Esto es opcional.",
    "This is your landlord’s information as registered with the <0>NYC Department of Housing and Preservation (HPD)</0>. This may be different than where you send your rent checks.": "Esta es la informaci\xF3n del due\xF1o de tu edificio seg\xFAn los registros del <0>Departamento de Preservaci\xF3n de la Vivienda (HPD por sus siglas en ingl\xE9s)</0>. Puede que sea distinta de donde env\xEDas tu cheque de renta.",
    "To begin the password reset process, we'll text you a verification code.": "Para restablecer tu contrase\xF1a, te enviaremos un c\xF3digo de verificaci\xF3n.",
    "To:": "A:",
    "Toilet leaking": "Inodoro con Fugas",
    "Toilet not working": "Inodoro No Funciona",
    "Trash cans": "Botes de basura",
    "USPS Tracking #:": "N\xFAmero de Seguimiento USPS:",
    "Unit/apt/lot/suite number": "N\xFAmero de apartamento/unidad/lote/suite",
    "Unrecognized address": "Direcci\xF3n no reconocida",
    "Unsafe/broken stairs and/or railing": "Escaleras y/o barandales inseguros/rotos",
    "Used for logging in to your account": "Se usa para ingresar a tu cuenta",
    "Utah": "Utah",
    "Utilities": "Utilidades",
    "Utilities shut off (water, gas, ... )": "Corte de los servicios p\xFAblicos (agua, gas, ... )",
    "Vacate order issued": "Orden de vac\xEDo emitida",
    "Verification code": "C\xF3digo de verificaci\xF3n",
    "Verify your phone number": "Verifica tu n\xFAmero de tel\xE9fono",
    "Vermont": "Vermont",
    "Virginia": "Virginia",
    "Visit Who Owns What": "Visita Qui\xE9n Es El Due\xF1o",
    "Washing machine not working": "Lavadora no funciona",
    "Washington": "Washington",
    "Water": "Agua",
    "Water damage": "Da\xF1o Por Agua",
    "Water leak": "Fuga de agua",
    "We've just sent you a text message containing a verification code. Please enter it below.": "Acabamos de enviarte un mensaje de texto que contiene un c\xF3digo de verificaci\xF3n. Por favor, introd\xFAcelo abajo.",
    "Weak electrical current": "Baja Corriente El\xE9ctrica",
    "Welcome back!": "\xA1Hola de nuevo!",
    "West Virginia": "Virginia Occidental",
    "What contact information do you have for your landlord or building management? <0>We recommend choosing both if you have them.</0>": "\xBFQu\xE9 informaci\xF3n de contacto tienes del due\xF1o o manager de tu edificio? <0>Sugerimos que elijas las dos opciones si las tienes.</0>",
    "What happens next?": "\xBFY ahora qu\xE9?",
    "What is your borough?": "\xBFCu\xE1l es tu municipalidad?",
    "Where do I find this information?": "\xBFD\xF3nde encuentro esta informaci\xF3n?",
    "Where do you live?": "\xBFD\xF3nde vives?",
    "Where we will send you your documents.": "Donde te enviaremos tus documentos.",
    "Whether it's your first time here, or you're a returning user, let's start with your number.": "Empecemos con tu n\xFAmero de tel\xE9fono, ya sea tu primera vez aqu\xED, o est\xE9s de vuelta.",
    "Who we are": "Qui\xE9nes somos",
    "Why do I need to create an account?": "\xBFPor qu\xE9 necesito crear una cuenta?",
    "Why do you need this information?": "\xBFPor qu\xE9 necesit\xE1is esta informaci\xF3n?",
    "Why we made this": "Por qu\xE9 hemos creado esta herramienta",
    "Window frame defective": "Marco de ventana defectuoso",
    "Window glass broken": "Cristal de ventana roto",
    "Window guards missing": "Faltan Protectores de Ventana",
    "Wisconsin": "Wisconsin",
    "Wyoming": "Wyoming",
    "Yes": "Si",
    "Yes, Sign Out": "S\xED, cerrar sesi\xF3n",
    "You already have an account": "Ya tienes una cuenta",
    "You can also track the delivery of your letter using USPS Tracking:": "Tambi\xE9n puede seguir la entrega de su carta usando USPS Tracking:",
    "You can contact Strategic Actions for a Just Economy (SAJE) - a 501c3 non-profit organization in South Los Angeles.": "Puedes contactar Acciones Estrat\xE9gicas para una Econom\xEDa Justa (SAJE) - una organizaci\xF3n sin fines de lucro 501c3 en el sur de Los Angeles.",
    "You have chosen to overwrite the landlord recommended by JustFix. Please provide your own details below, or <0>use the recommended landlord \"{0}\"</0>.": function (a) {
  return ["Has elegido sustituir la informaci\xF3n recomendada por JustFix sobre el due\xF1o de tu edificio. Por favor proporciona tu propia informaci\xF3n a continuaci\xF3n, o <0>usa el due\xF1o recomendado\"", a("0"), "\"</0>."];
},
    "Your apartment may be rent stabilized.": "Tu apartamento es de renta estabilizada.",
    "Your building had {0, plural, one {one rent stabilized unit} other {# rent stabilized units}} in {1}.": function (a) {
  return ["Tu edificio ten\xEDa ", a("0", "plural", {
    one: "una unidad de alquiler estabilizado",
    other: ["#", " unidades de renta estabilizada"]
  }), " en el ", a("1"), "."];
},
    "Your building was built in {0} or earlier.": function (a) {
  return ["Tu edificio fue construido en ", a("0"), " o antes."];
},
    "Your email address": "Tu direcci\xF3n de correo electr\xF3nico",
    "Your landlord is associated with {0, plural, one {one building} other {# buildings}} and {1, plural, one {one unit.} other {# units.}}": function (a) {
  return ["El due\xF1o de su edificio est\xE1 asociado con ", a("0", "plural", {
    one: "un edificio",
    other: ["#", " edificios"]
  }), " y ", a("1", "plural", {
    one: "una unidad.",
    other: ["#", " unidades."]
  })];
},
    "Your landlord is associated with {buildings, plural, one {one building} other {# buildings}}.": function (a) {
  return ["El proprietario de tu edificio est\xE1 asociado con ", a("buildings", "plural", {
    one: "un edificio",
    other: ["#", " edificios"]
  }), "."];
},
    "Your landlord may be breaking the law!": "\xA1Puede que el proprietario de tu edificio est\xE9 violando la ley!",
    "Your landlord might own other buildings, too.": "Puede que el propietario de tu edificio tambi\xE9n posea otros edificios.",
    "Your landlord or management company's address": "La direcci\xF3n del due\xF1o o manager de tu edificio",
    "Your landlord or management company's email": "La direcci\xF3n de correo electr\xF3nico del due\xF1o o manager de tu edificio",
    "Your landlord or management company's information": "Los datos del due\xF1o o manager de tu edificio",
    "Your letter was sent on {0}.": function (a) {
  return ["Tu carta fue enviada el ", a("0"), "."];
},
    "Your phone number": "Tu n\xFAmero de tel\xE9fono",
    "Your privacy is very important to us": "Tu privacidad es importante para nosotros",
    "Your privacy is very important to us. Everything on JustFix is secure.": "Su privacidad es muy importante para nosotros. Todo en JustFix es seguro.",
    "Your residence": "Tu hogar",
    "Zip code": "C\xF3digo postal",
    "justfix.DdoMayNeedHpdRegistration": "Parece que este edificio deba estar registrado con el HPD. Los proprietarios que no registren sus propiedades correctamente incurren multas y no tienen el derecho de llevar a los inquilinos a la corte por no pagar el alquiler. Puedes encontrar m\xE1s informaci\xF3n en la p\xE1gina <0>Gesti\xF3n de Propiedades de HPD</0>",
    "justfix.commonWarningAboutChangingLandlordDetails1": "Si recibes documentos relacionados con el alquiler desde una direcci\xF3n diferente, o si el due\xF1o de tu edificio te ha dado instrucciones de usar una direcci\xF3n diferente para vuestra correspondencia, puedes <0>proporcionar tus propios datos.</0> Sin embargo, s\xF3lo debes usar una direcci\xF3n distinta a la que te sugerimos si tienes la certeza absoluta de que es correcta\u2014es m\xE1s seguro usar la direcci\xF3n oficial que el due\xF1o de tu edificio ha registrado con la ciudad.",
    "justfix.ddoEhpaDeactivatedMessage": "A partir de junio de 2021, La Corte de Vivienda ha impedido que los inquilinos demanden a sus due\xF1os a trav\xE9s de la herramienta HP Action de JustFix. Para aprender c\xF3mo presentar una Acci\xF3n de HP ahora, lee nuestra <0>art\xEDculo de Medium</0>. Para aprender m\xE1s acera de Acciones de HP y encontrar una lista de proveedores legales, visita <1>Housing Court Answers</1>.",
    "justfix.ddoLocCovidMessage": "\xBFEl due\xF1o de tu edificio no contesta? \xA1Puedes tomar acci\xF3n gratis para pedir arreglos! Debido a la crisis de salud por el Covid-19, te recomendamos que s\xF3lo pidas arreglos en caso de emergencia, para que puedas mantener la salud limitando cu\xE1ntas personas entran a tu hogar.",
    "justfix.howIsPersonalInfoProtectedV2": "Todo en JustFix es seguro. No usamos tu informaci\xF3n personal con fines de lucro ni la vendemos a terceros. Ve nuestra <0/>.",
    "justfix.legalDisclaimer": function (a) {
  return ["Aviso: La informaci\xF3n en ", a("website"), " no constituye asesoramiento jur\xEDdico y no debe ser utilizado como sustituto del asesoramiento de un abogado cualificado para asesorar sobre cuestiones jur\xEDdicas relativas a la vivienda. Si lo necesitas, podemos ayudar a dirigirte a servicios legales gratuitos."];
},
    "justfix.privacyInfoModalTextV2": "<0>Tu privacidad es muy importante para nosotros. Aqu\xED hay algunas cosas importantes que debes saber: </0><1><2>Tu informaci\xF3n personal est\xE1 segura.</2><3>No usamos tus datos personales con fines de lucro ni los vendemos a terceros.</3><4>Usamos tu direcci\xF3n para encontrar informaci\xF3n del propietario y de tu edificio.</4></1><5>Nuestra Pol\xEDtica de privacidad permite compartir datos an\xF3nimos con organismos aprobados de abogac\xEDa para inquilinos exclusivamente para ayudar a impulsar nuestra misi\xF3n de los derechos de inquilinos. La Pol\xEDtica de privacidad contiene informaci\xF3n con respecto a datos recopilamos, c\xF3mo los usamos y las opciones que tienes en cuanto a tu informaci\xF3n personal. Si te gustar\xEDa leer m\xE1s, por favor repasa nuestra <6/> y <7/> completa.</5>",
    "justfix.whyIsAccountNeeded": "Una cuenta te permite crear, enviar y acceder de forma segura a las cartas que te ayuden a ejercer tus derechos de inquilino.",
    "justfix.whyIsPhoneNumberNeeded": "Utilizaremos esta informaci\xF3n para:<0><1>Acceder a tu cuenta actual</1><2>Comprobar si coincide con una cuenta preexistente </2><3>Abrirte una cuenta nueva.</3></0><4/>Una cuenta te permitir\xE1 volver a nuestras herramientas en cualquier punto del proceso sin tener que empezar desde el principio, descargar cualquier documentos que hayas completado, y recibir notificaciones sobre cambios relevantes a pol\xEDticas que te afecten.",
    "norent.sajeBlockQuote": "Desde 1996, SAJE ha sido una fuerza para la justicia econ\xF3mica en nuestra comunidad, centr\xE1ndose en los derechos de los inquilinos, la vivienda saludable y el desarrollo equitativo. Creemos que el destino de los vecindarios de la ciudad debe ser decidido por quienes viven all\xED, y nos reunimos con otras organizaciones para garantizar que esto ocurra de manera justa, replicable y sostenible. La vivienda es un derecho humano.",
    "norent.sajePhoneCalls": "Acciones Estrat\xE9gicas para una Econom\xEDa Justa (SAJE) est\xE1 disponible para llamadas telef\xF3nicas en el (213) 745-9961, de lunes a viernes de 10:00am-6:00pm.",
    "{0} (in English)": function (a) {
  return [a("0"), " (en ingl\xE9s)"];
},
    "{remaining, plural, one {1 character remaining} other {# characters remaining}}": function (a) {
  return [a("remaining", "plural", {
    one: "queda s\xF3lo 1 car\xE1cter",
    other: ["quedan ", "#", " caracteres"]
  })];
},
  },
};